import mixitup from 'mixitup';
import mixitupMultifilter from './vendor/mixitup-multifilter';
import mixitupPagination from './vendor/mixitup-pagination';

mixitup.use(mixitupMultifilter);
mixitup.use(mixitupPagination);

var containerEl = document.querySelector('.cardContainer');
var targetSelector = '.mix';
var activeHash = '';

/**
* Deserializes a hash segment (if present) into in an object.
*
* @return {object|null}
*/

function deserializeHash() {
  var hash = window.location.hash.replace(/^#/g, '');
  var obj = null;
  var groups = [];

  if (!hash) return obj;

  obj = {};
  groups = hash.split('&');

  groups.forEach(function (group) {
    var pair = group.split('=');
    var groupName = pair[0];

    obj[groupName] = pair[1].split(',').map(decodeURIComponent);
  });

  return obj;
}

/**
* Serializes a uiState object into a string.
*
* @param   {object}    uiState
* @return  {string}
*/

function serializeUiState(uiState) {
  var output = '';

  for (var key in uiState) {
    var values = uiState[key];

    if (!values.length) continue;

    values = values.map(encodeURIComponent);

    output += key + '=';
    output += values.join(',');
    output += '&';
  };

  output = output.replace(/&$/g, '');

  return output;
}

/**
* Constructs a `uiState` object using the
* `getFilterGroupSelectors()` API method.
*
* @return {object}
*/

function getUiState() {
  // NB: You will need to rename the object keys to match the names of
  // your project's filter groups – these should match those defined
  // in your HTML.

  var uiState = {
    search: mixer.getFilterGroupSelectors('search').map(getValueFromSelector),
    topic: mixer.getFilterGroupSelectors('topic').map(getValueFromSelector),
    type: mixer.getFilterGroupSelectors('type').map(getValueFromSelector)
  };

  return uiState;
}

/**
* Updates the URL hash whenever the current filter changes.
*
* @param   {mixitup.State} state
* @return  {void}
*/

function setHash(state) {
  var selector = state.activeFilter.selector;

  // Construct an object representing the current state of each
  // filter group

  var uiState = getUiState();

  // Create a URL hash string by serializing the uiState object

  var newHash = '#' + serializeUiState(uiState);

  if (selector === targetSelector && window.location.href.indexOf('#') > -1) {
    // Equivalent to filter "all", and a hash exists, remove the hash

    activeHash = '';

    history.replaceState(null, document.title, window.location.pathname);
  } else if (newHash !== window.location.hash && selector !== targetSelector) {
    // Change the hash

    activeHash = newHash;

    history.replaceState(null, document.title, window.location.pathname + newHash);
  }
}

/**
* Updates the mixer to a previous UI state.
*
* @param  {object|null}    uiState
* @param  {boolean}        [animate]
* @return {Promise}
*/

function syncMixerWithPreviousUiState(uiState, animate) {
  var search = (uiState && uiState.search) ? uiState.search : [];
  var topic = (uiState && uiState.topic) ? uiState.topic : [];
  var type = (uiState && uiState.type) ? uiState.type : [];

  mixer.setFilterGroupSelectors('search', search.map(getSelectorFromValue));
  mixer.setFilterGroupSelectors('topic', topic.map(getSelectorFromValue));
  mixer.setFilterGroupSelectors('type', type.map(getSelectorFromValue));

  // Parse the filter groups (passing `false` will perform no animation)

  return mixer.parseFilterGroups(animate ? true : false);
}

/**
* Converts a selector (e.g. '.green') into a simple value (e.g. 'green').
*
* @param   {string} selector
* @return  {string}
*/

function getValueFromSelector(selector) {
  selector = selector.replace(/^\./, '');
  return selector;
}

/**
* Converts a simple value (e.g. 'green') into a selector (e.g. '.green').
*
* @param   {string} selector
* @return  {string}
*/

function getSelectorFromValue(value) {
  if(/\[.*/.test(value)){
    return value;
  } else {
    return '.' + value;
  }
  
}

var uiState = deserializeHash();

// Instantiate MixItUp

var mixer = mixitup(containerEl, {
  selectors: {
    target: targetSelector
  },
  load: {
    sort: 'random'
  },
  pagination: {
    limit: 14
  },
  multifilter: {
    enable: true
  },
  controls: {
    toggleLogic: "and"
  },
  animation: {
    effects: 'fade translateZ(-100px)'
  },
  callbacks: {
    onMixEnd: function (state) {
      if (state.hasFailed) {
        noItemsFoundMessage.style.display = "flex";
      }
      else {
        noItemsFoundMessage.style.display = "none";
      }
      setHash(state);
      window.scroll({ top: 0, left: 0, behavior: 'smooth' });

    },
  } //end of callbacks
});

if (uiState) {
  // If a valid uiState object is present on page load, filter the mixer
  syncMixerWithPreviousUiState(uiState);
}

// Resource Filters Toggle

// Trigger 
const resourceFiltersTrigger = document.getElementById("resourceFiltersTrigger");
const resourceFilters = document.getElementById("resourceFilters");

resourceFiltersTrigger.addEventListener("click", function () {
  if (this.classList.contains('visible') || resourceFilters.classList.contains('visible')) {
    this.classList.remove("visible");
    this.setAttribute("aria-expanded", "false");
    resourceFilters.classList.remove("visible");
  } else {
    this.classList.add("visible");
    this.setAttribute("aria-expanded", "true");
    resourceFilters.classList.add("visible");
  }
});
